﻿(function ($) {
	$.ajaxSetup({ cache: false });

	$(function () {
		window.global.setTabIndex("#header", 11, null);
		window.global.setTabIndex("#global-nav", 20, null);
		window.global.setTabIndex("#main-nav", 30, null);
		window.global.setTabIndex("#md", 40, null);
		window.global.setTabIndex("#quick-search", 101, null);
		window.global.setTabIndex("#gps", 111, null);
		window.global.setTabIndex("#page-info", 131, null);
		window.global.setTabIndex(".ui-tabs-page", 171, null);
		window.global.setTabIndex("#content", 181, null);
		window.global.setTabIndex(".shortcuts", 400, null);
		window.global.setTabIndex(".footer-sub", 400, null);
		window.global.setTabIndex(".divide-txt", 450, null);
		$('#page-wrapper').find('.ui-tabs-page li:not(.active) a').pjax('#content', {
			delay: 300,
			timeout: 5000,
			urlFormat: "{url}?template=ajaxcontent"
		});

		$('#global-nav').find('.menu-link').dropdown({
			offset: {
				top: -50,
				left: -5
			},
			delayIn: 50,
			speed: 100
		}).end().find('.ui-dropdown').hoverhelper({
			vertical: true,
			hoverClass: "sel",
			speed: 100,
			alwaysVisible: false
		});

		$LAB.$LAB.setGlobalDefaults({ CacheBust: true });

		$('#content').data("pjax-before", function (link, container) {
			var contentWrapper = container.parent();

			// Remove outline border
			link.css("outline", "none");

			container.data("pjax-loading", true);

			// Set the height on content wrapper same as container
			contentWrapper.css("height", container.height());

			container.fadeOut(200, function () {
				// Show loading icon
				if (container.data("pjax-loading")) {
					window.global.showLoadingIcon("#content-wrapper");
				}

				// Set the active tab
				link.closest("li").addClass("active").siblings().removeClass("active").removeClass('child-sel');
			});
		}).data("pjax-after", function (link, container, insertContent, html, insertInlineScript) {
			var contentWrapper = container.parent();
			var result = $(html);

			container.data("pjax-loading", false);

			// update gps
			$('#gps').after(result.find('#gps').remove()).remove();

			// insert links and scripts
			$('head').append(result.filter('link'));

			var scripts = result.filter("script[src]").map(function () { return $(this).attr("src"); }).get();

			var inlineScripts = "";
			result.filter("script:not([src])").map(function () {
				inlineScripts += $(this).html();
			});

			var remaining = scripts.length;

			$LAB.$LAB.script(scripts, function () {
				// Insert new content
				insertContent(result.filter('.row'));

				// Hide the loading icon
				window.global.hideLoadingIcon("#content-wrapper");

				// Set the content as absolute and hide it so we can get the height
				container.css({
					position: "absolute",
					visibilty: "hidden"
				});

				// Animate the content wrapper
				contentWrapper.animate({
					height: container.height()
				}, 400, function () {

					// Set the height on wrapper to auto since we don't need the height anymore
					contentWrapper.css("height", "auto");

					// Set the content back to relative position
					container.css({
						position: "relative"
					});
				});

				// Fade in the content
				container.fadeIn(600);
				container.lazyload();
			}).wait(function () {
				// Insert inline scripts
				insertInlineScript(inlineScripts);
			});
		}).lazyload();
		$('#main-nav .nav').megadropdown({ withClass: "has-dropdown" });

		var gps = {
			timer: 0,
			timeout: 1500,
			hideAll: function (hasAnimation) {
				var parent = $("#gps ul:first");
				$("li ul", parent).each(function () {
					if ($(this).is(":visible")) {
						if (hasAnimation) {
							$(this).slideUp(function () {
								$(this).parent().removeClass("sel");
							});
						}
						else {
							$(this).hide().parent().removeClass("sel");
						}
					}
				});
			},
			showChild: function (obj) {
				gps.hideAll(false);
				obj.next("span").next("ul").show().parent().addClass("sel");
			},
			setActive: function (obj, isActive) {
				if (isActive) {
					obj.addClass("active");
				} else {
					obj.removeClass("active");
				}
			},
			setSelected: function (obj, isSelected) {
				if (isSelected) {
					obj.addClass("sel");
				} else {
					obj.removeClass("sel");
				}
			}
		};

		$("#gps .nav-toggle").live("click", function () {

			//Parent UL
			var parent = $("#gps ul:first");
			var current = $(this).next("ul");
			var i = 0;

			//Set Order Data
			$("li ul", parent).each(function () {
				$(this).data("order", i++);
			});

			//If current is visible
			if (current.is(":visible")) {
				//Hide current
				current.slideUp(function () {
					gps.setSelected(current.parent(), false);
				});
				gps.setActive(parent, false);
			}
			else {
				//Show current, but first hide others
				$("li ul", parent).each(function () {
					//Not current
					if ($(this).data("order") != current.data("order")) {
						$(this).slideUp(function () {
							gps.setSelected($(this).parent(), false);
						});
						gps.setActive(parent, false);
					}
				});
				current.slideDown();
				gps.setActive(parent, true);
				gps.setSelected(current.parent(), true);
			}
		});


		//Hover when active
		$("#gps ul.active > li > a").live("hover",
			function (e) {
				gps.showChild($(this));
			}
		);
		//When clicked somewhere on the document outside GPS
		$('body').mouseup(function (e) {
			//If not clicked on the open megadropdown itself we close it
			if (!$(e.target).parents('#gps').length) {
				gps.hideAll(true);
				var parent = $("#gps ul:first");
				gps.setActive(parent, false);
			}
		});
		//Hide all when we leave
		$("#gps").live('mouseleave', function (e) {
			gps.timer = setTimeout(function () {
				gps.hideAll(true);
				var parent = $("#gps ul:first");
				gps.setActive(parent, false);
			}, gps.timeout);
		}).live('mouseenter', function () {
			clearTimeout(gps.timer);
		});


		/* Setting focus class on parent  */
		$(".ui-form .btn").focus(function () {
			$(this).parent().addClass("focus");
		});

		$(".ui-form .btn").blur(function () {
			$(this).parent().removeClass("focus");
		});

		$(".justify").justify();

		$('#tab-control').find('.ui-tabs-sub').hoverhelper();
	});

})(jQuery);